 // Lib Imports
import Vue from 'vue'

import RecentClasses from './RecentClasses'
import ClassTypes from './ClassTypes'

import Community from './core/partials/Community'
import MyProfile from './core/partials/MyProfile'
import LiveClasses from './core/partials/LiveClasses'
import VideoTypes from './core/partials/VideoTypes'

Vue.component('recent-classes', RecentClasses)
Vue.component('class-types', ClassTypes)

Vue.component('core-partials-community', Community)
Vue.component('core-partials-myProfile', MyProfile)
Vue.component('core-partials-liveClasses', LiveClasses)
Vue.component('core-partials-videoTypes', VideoTypes)
